import styled from 'styled-components';
import { MTextBlockFullAlignment } from './MTextBlockFull.types';
interface WrapperProps {
  $alignment: MTextBlockFullAlignment;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $alignment }) => ($alignment === MTextBlockFullAlignment.Centered ? 'center' : 'flex-start')};
  text-align: ${({ $alignment }) => ($alignment === MTextBlockFullAlignment.Centered ? 'center' : 'start')};
  inline-size: 100%;
`;

export const EyebrowWrapper = styled.div`
  margin-block-end: 0.5rem;
`;

export const HeaderWrapper = styled.div`
  margin-block-end: 0.75rem;
`;

export const AccentLineWrapper = styled.div`
  inline-size: 100%;
`;

export const SubheaderWrapper = styled.div`
  margin-block-end: 0.25rem;
`;

export const BodyWrapper = styled.div`
  margin-block-end: 0;
`;
